import React from 'react';
import * as XLSX from 'xlsx';

const AdminReports = ({ attendanceRecords, employees }) => {
  
  const handleExportExcel = () => {
    // Preparar datos para excel
    const data = attendanceRecords.map(record => {
      // Find employee to check tardiness (if we implemented it)
      const emp = employees.find(e => e.id === record.employeeId);
      
      let observaciones = "";
      if (emp && record.type === 'entrada') {
        const expectedTime = emp.scheduleStart || "08:00";
        if (record.time > expectedTime + ":59") {
          observaciones = "Tardanza";
        }
      }

      return {
        "DNI": record.dni,
        "Empleado": record.employeeName,
        "Fecha": record.date,
        "Hora": record.time,
        "Tipo": record.type.toUpperCase(),
        "Observaciones": observaciones
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Asistencias");
    
    // Generar archivo
    XLSX.writeFile(workbook, `Reporte_Asistencias_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  return (
    <div className="space-y-8 max-w-4xl mx-auto animate-fade-in-up">
      <div className="glass-card p-8 rounded-2xl border-slate-800/80 text-center">
        <div className="w-16 h-16 bg-blue-500/10 text-blue-400 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <h3 className="text-2xl font-bold text-slate-100 mb-2">Exportar Reportes</h3>
        <p className="text-slate-400 mb-8 max-w-md mx-auto">
          Descarga todo el historial de asistencias en formato Excel para procesar planillas o realizar auditorías.
        </p>

        <button 
          onClick={handleExportExcel}
          className="px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white font-semibold rounded-xl shadow-lg shadow-blue-500/20 transition-all duration-200 flex items-center gap-2 mx-auto"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
          Descargar Excel (.xlsx)
        </button>
      </div>
    </div>
  );
};

export default AdminReports;
